export enum CommunicationProtocol {
  ESC_POS = 'ESC_POS',
  ZPL = 'ZPL',
}

export interface Printer {
  id: string;

  name: string;

  description?: string;

  hostId?: string;

  divisionId?: string;

  connectionType?: string;

  ipAddress?: string;

  port?: number;

  portPath?: string;

  baudRate?: number;

  databits?: number;

  parity?: string;

  stopbits?: number;

  flowControl?: string;

  vendorId?: string;

  productId?: string;

  hostName?: string;

  divisionName?: string;

  communicationProtocol: CommunicationProtocol;

  zplContent?: string;
}
